import { render, staticRenderFns } from "./unemployed.vue?vue&type=template&id=78233fb9&scoped=true"
import script from "./unemployed.vue?vue&type=script&lang=js"
export * from "./unemployed.vue?vue&type=script&lang=js"
import style0 from "./unemployed.vue?vue&type=style&index=0&id=78233fb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78233fb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78233fb9')) {
      api.createRecord('78233fb9', component.options)
    } else {
      api.reload('78233fb9', component.options)
    }
    module.hot.accept("./unemployed.vue?vue&type=template&id=78233fb9&scoped=true", function () {
      api.rerender('78233fb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/unemployed.vue"
export default component.exports